import { render, staticRenderFns } from "./ListagemProcessosLicitacaoTabela.vue?vue&type=template&id=5f229217&scoped=true&"
import script from "./ListagemProcessosLicitacaoTabela.vue?vue&type=script&lang=js&"
export * from "./ListagemProcessosLicitacaoTabela.vue?vue&type=script&lang=js&"
import style0 from "./ListagemProcessosLicitacaoTabela.vue?vue&type=style&index=0&id=5f229217&prod&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f229217",
  null
  
)

export default component.exports